import axios from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { FileOriginType, StorageFileProps, StorageFileServiceProps } from 'models/StorageFile';

import Services from './index.service';

export default class StorageFileService extends Services<StorageFileServiceProps, StorageFileProps> {

  getUrlWithSasToken = async (url: string, fileOrigin: FileOriginType = FileOriginType.CUSTOMER_CARE) => {
    const config: IRequestConfig<StorageFileProps> = {
      url: `${this.base_url}/storage-file/get-url-sas-token`,
      method: MethodsTypes.post,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.access_token()}`
      },
      data: {
        url: url,
        fileOrigin: fileOrigin
      }
    };

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );

    return axios(config)
      .then((result) => { return result; });
  };

}
